<template>
  <div
    class="tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-dark-green tw-p-8"
  >
    <div>
      <div>
        <img
          src="@/assets/svgs/invitation/disco.svg"
          alt="Disco Ball"
          class="tw-mx-auto tw-mb-4 tw-w-36 tw-h-36"
        />
        <h2
          class="tw-text-lg tw-font-semibold tw-text-chartreuse tw-w-4/6 tw-mx-auto"
        >
          You're in! Let's get the trip going.
        </h2>
        <ul
          class="tw-pl-4 tw-text-white tw-text-18 tw-font-bold tw-w-4/6 tw-mx-auto tw-mt-10 md:tw-w-3/6 md:tw-pl-0"
        >
          <li class="tw-flex tw-flex-row tw-items-center">
            <img
              class="tw-mr-4"
              src="@/assets/svgs/invitation/list-bullet.svg"
              alt="Star"
            /><span>Post Ideas</span>
          </li>
          <li class="tw-flex tw-flex-row tw-items-center">
            <img
              class="tw-mr-4"
              src="@/assets/svgs/invitation/list-bullet.svg"
              alt="Star"
            />
            <span>See who's going</span>
          </li>
          <li class="tw-flex tw-flex-row tw-items-center">
            <img
              class="tw-mr-4"
              src="@/assets/svgs/invitation/list-bullet.svg"
              alt="Star"
            /><span>Stay in the know</span>
          </li>
        </ul>
        <v-btn
          rounded
          color="primary"
          x-large
          class="tw-mt-40 tw-mb-6 tw-tracking-normal"
          :to="{ name: 'TripViewRoute', params: { id: tripId } }"
          >Go to Trip Hub</v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tripId: this.$route.params.id
    };
  }
};
</script>
